import { DocTypes } from "../common/constants/DocTypes";

/**
 * @deprecated
 */
export interface DocumentFile {
    name: string,
}

/**
 * @deprecated
 */
export interface DocumentType {
    role: DocTypes,
}

export enum ModifiableValue {
    Account = "account",
    To = "to",
    From = "from",
    Description = "description",
    Source = "source",
    State = "state",
    FeeSchedule = "feeSchedule",
}

export interface DocumentUpdateRequest {
    documentId: string,
    fileDescription: string,
    recordSourceId: number | undefined,
    fromDateOfService: Date | undefined,
    toDateOfService: Date | undefined,
    account: string,
    feeScheduleId: number | undefined,
    state: string | undefined,
}

export interface DocumentUpdateRequests {
    transactionId: string,
    userId: number,
    updates: DocumentUpdateRequest[],
}

export interface DocumentUploadRequest {
    readonly fileName: string;
    readonly fileID: string;
    readonly recordType: string;
    readonly file: File;
    readonly transactionId: string;
    readonly state?: string;
    readonly append: boolean;
    readonly uploadProgress: (progress: any) => void;
    /**
     * Whether Quick Entry is the active mode for this transaction (the same
     * value DataEntryDetails.isQuickEntryEligible() computes). Classic mode -
     * including the old-Intake "Extract" button surface - must never
     * auto-trigger extraction on upload; only Quick Entry's document-first
     * flow does. See autoExtractOnRequestUpload.
     */
    readonly quickEntryActive?: boolean;
}

export default interface TransactionDocument {
    id: string,
    source?: string,
    sourceID?: number,
    description: string,
    pageCount: number,
    reportOrder: number,
    header: string,
    transaction: any,
    /**
     * File size in bytes
     */
    size?: number,
    /**
     * @deprecated
     */
    file: DocumentFile,
    /**
     * @deprecated Replaced by `recType`
     */
    type: DocumentType,
    recType: DocTypes,
    sab: string,
    account: string,
    dateOfService?: Date,
    dateToService?: Date,
    reqItemInTcId?: number,
    lastUpdate?: Date,
    syncDate?: Date,
    state?: string,
    feeScheduleId?: number,
    /**
     * @deprecated Components should keep track of editing on their own.
     */
    isEditing: boolean
}

export function documentFromApiResponse(item: any): TransactionDocument {
    const fileSize = Number(item.file?.size?.bytes);
    const from: string | undefined = item.dateOfService;
    const to: string | undefined = item.dateToService;
    return {
        ...item,
        recType: item.type.role,
        size: fileSize || undefined,
        dateOfService: from && !from.startsWith("1900-01-01") ? new Date(from) : undefined,
        dateToService: to && !to.startsWith("1900-01-01") ? new Date(to) : undefined,
        lastUpdate: item.lastUpdate ? new Date(item.lastUpdate) : undefined,
        syncDate: item.syncDate ? new Date(item.syncDate) : undefined,
        isEditing: false,
    }
}
